import Vue from 'vue';
import Asb3Sender from 'razlet-sdk/lib/api/asb3-sender';
import {sendError} from '~/utils/error';
import TabloList from '~/entities/tablo-list';
import ScheduleList from '~/entities/schedule-list';
// import sulu from './sulu';

function numberDivision(value) {
  if (value === null) return '';
  if (!value) return '0'; 
  value = String(value);
  const dotIndex = value.indexOf('.');
  if (dotIndex > -1) {
    const stepAfterDot = value.length > dotIndex + 3 ? 3 : value.length - dotIndex;
    value = value.substr(0, dotIndex + stepAfterDot);
  }
  return value.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
}

const state = () => ({
  ua: /iPhone|iPad|iPod|Android|Windows Phone/.test(typeof window !== 'undefined' ? window.navigator.userAgent : ''),
  mobile: false,
  offline: false,
  host: null,
  pricesList: [],
});

const mutations = {
  setMobile(state, value) {
    state.mobile = value;
  },
  setOffline: (state, value) => {
    state.offline = value;
  },
  modifyPricesStatistic: (state, { request, calendar }) => {
    const _today = new Date();
    const today = new Date(_today.getFullYear(), _today.getMonth(), _today.getDate(), 0, 0, 0);
    let element = state.pricesList.find(value => value.departure === request.departure && value.arrival === request.arrival);
    if (typeof element === 'undefined') {
      element = {
        departure: request.departure,
        arrival: request.arrival,
        dateStart: today,
        prices: Array.from({ length: 440 }, () => ({ price: null })),
      };
      state.pricesList.push(element);
    }
    calendar.forEach((item) => {
      const priceIndex = Math.ceil((new Date(`${item.date.replace(/-/g, '/')} 00:00:00`).getTime() - today.getTime()) / (24 * 3600 * 1000));
      element.prices[priceIndex] = { ...item, price: item.price ? `${numberDivision(item.price)} ₽` : null };
    });
  },
};

const getters = {
  isMobile(state) {
    return state.mobile;
  },
  isOffline(state) {
    return state.offline;
  },
  hasPrices: (state) => (departure, arrival) => {
    return !!state.pricesList.find(value => value.departure === departure && value.arrival === arrival);
  },
  getPricesStatistic: (state) => (departure, arrival) => {
    const element = state.pricesList.find(value => value.departure === departure && value.arrival === arrival);
    if (typeof element === 'undefined') {
      return {
        departure,
        arrival,
        dateStart: new Date(),
        prices: Array.from({ length: 440 }, () => ({ price: null })),
      };
    }
    return element;
  },
};

const actions = {
  async nuxtServerInit ({ dispatch }, {app, req, isDev}) {
    const currentLang = app.$cookiz.get('defaultLanguage') || 'ru';
    Vue.prototype.$locale = currentLang;
    await app.i18n.setLocale(currentLang);
    await dispatch('sulu/initSuluSender', {req, isDev, requests: ['getMenu']});
  },
  async getTablo({state}, req) {
    const asb3Sender = new Asb3Sender();
    const response = await asb3Sender.get(`/api/web/schedule/yamal/flight-table?city=${state.sulu.about.code}&${req.buildRequest()}`, null)
      .then(res => {
        return Promise.resolve(new TabloList(res.data, req.timeOptions, req.direction.altValue));
      })
      .catch(e => {
        sendError(e);
      });
    return response;
  },
  // eslint-disable-next-line no-empty-pattern
  async getSchedule({}, req) {
    const asb3Sender = new Asb3Sender();
    const response = await asb3Sender.get(`/api/web/schedule${req.buildRequest()}company=YC`, null)
      .then(res => {
        return Promise.resolve(new ScheduleList(req, res.data));
      })
      .catch(e => {
        sendError(e);
      });
    return response;
  },
};

export default {
  strict: false,
  state,
  getters,
  mutations,
  actions,
  // modules: {
  //   sulu: {
  //     namespaced: true,
  //     ...sulu,
  //   },
  // },
};